import { Box } from '@mui/material'
import { IContractShortResponse, ROLE } from 'api'
import {
  AvailableLicensesList,
  ChangeRoleSelect,
  CollapsibleRow,
  LicensesEndDatesList,
  TextField,
  UserDeleteButton,
} from 'modules/common/components'
import { LOCALE, Locale, TEXT } from 'modules/locale'
import { ITableUser } from 'modules/organization/components/EmployeesTable/models'
import React from 'react'

const locale = localStorage.getItem('locale') || LOCALE.RUSSIAN
const T = TEXT.USER[locale as Locale]
type SubRowData = {
  id: string
  email: string
  fullName: string,
}
const createSubRow = (data: SubRowData, onDelete?: (userId: string) => void, isDeleting?: boolean) => {
  const { id, email, fullName } = data
  return (
    <Box display='flex' alignItems='center' gap='20px'>
      <TextField label={T.email} value={email} InputProps={{ readOnly: true }} sx={{ minWidth: '380px' }} />
      <TextField label={T.userId} value={id} InputProps={{ readOnly: true }} sx={{ minWidth: '380px' }} />
      {onDelete && (
        <Box ml='auto'>
          <UserDeleteButton userId={id} userName={fullName} isDeleting={isDeleting} onDelete={onDelete} />
        </Box>
      )}
    </Box>
  )
}

export const createRows = (
  users: ITableUser[] | undefined,
  contracts: IContractShortResponse[] | undefined,
  myId: string | undefined,
  onRoleChange: (userId: string, role: ROLE) => void,
  isRoleChanging: boolean,
  onUserDelete: (userId: string) => void,
  isDeleting: boolean,
  companyId?: string,
): CollapsibleRow[] => {
  if (!users || !contracts) {
    return []
  }

  return users.map(user => {
    const subRowData: SubRowData = {
      id: user.user_id,
      email: user.email_login,
      fullName: `${user.contact_info.name} ${user.contact_info.surname}`,
    }

    return {
      id: user.user_id,
      employee: `${user.contact_info.name} ${user.contact_info.surname}`,
      role: (
        <ChangeRoleSelect
          rolesList='org'
          role={user.role}
          userId={user.user_id}
          isLoading={isRoleChanging}
          onRoleChange={user.user_id === myId ? undefined : onRoleChange}
        />
      ),
      availableLicenses: <AvailableLicensesList contracts={contracts} userId={user.user_id} companyId={companyId} />,
      validity: <LicensesEndDatesList contracts={contracts} userId={user.user_id} />,
      subRow: createSubRow(subRowData, user.user_id !== myId ? onUserDelete : undefined, isDeleting),
    }
  })
}
